// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__hLZYy","checkboxCol":"Table_checkboxCol__4YI0r","emailCol":"Table_emailCol__1UnKV","actionCol":"Table_actionCol__2ueRo"};